import { Component } from '@angular/core';
import { InputComponent } from '../../utilities/input/input.component';
import { OtpFieldComponent } from '../../components/otp-field/otp-field.component';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ButtonComponent } from "../../utilities/button/button.component";

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [InputComponent, OtpFieldComponent, CommonModule, ButtonComponent],
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
})
export class RegisterComponent {
  registerData: any = {
    companyName: '',
    emailAddress: '',
    description: '',
    directorName: '',
  };
  errors = {
    companyName: '',
    emailAddress: '',
    description: '',
    directorName: '',
  };
  otp: string = '';
  otpId: string = '';
  loading: boolean = false;
  texts: string[] = [
    'Engage Customers. Boost Loyalty. Drive Growth.',
    'Create Rewards That Keep Your Customers Coming Back',
    'Drive Customer Retention with Tailored Rewards',
    'Boost Engagement with Easy-to-Create Rewards',
  ];
  currentText: string = '';
  isDeleting: boolean = false;
  loopIndex: number = 0;
  charIndex: number = 0;
  typingSpeed: number = 150;
  backspaceSpeed: number = 75;
  pauseTime: number = 1000;
  OTPState: boolean = false;

  constructor(private router: Router, private authService: AuthService, private notification: NzNotificationService,) {}

  ngOnInit(): void {
    this.startTypingEffect();
  }

  routeTo = (route: string) => {
    this.router.navigate([`/${route}`]);
  };

  setCompanyName = (value: string) => {
    this.registerData.companyName = value;
    if (value === '') {
      this.errors.companyName = 'Required*';
      return;
    } else {
      this.errors.companyName = '';
    }
  };
  setDescription = (value: string) => {
    this.registerData.description = value;
    if (value === '') {
      this.errors.description = 'Required*';
      return;
    } else {
      this.errors.description = '';
    }
  };
  setDirectorName = (value: string) => {
    this.registerData.directorName = value;
    if (value === '') {
      this.errors.directorName = 'Required*';
      return;
    } else {
      this.errors.directorName = '';
    }
  };
  setEmail = (value: string) => {
    this.registerData.emailAddress = value;
    if (value === '') {
      this.errors.emailAddress = 'Required*';
    } else if (!this.validateEmail(value)) {
      this.errors.emailAddress = 'Please use a valid email*';
    } else {
      this.errors.emailAddress = '';
    }
  };
   validateForm = () => {
    const errors: any = {};
    if (this.registerData.companyName === '') {
      errors.companyName = 'Required*';
    }
    if (this.registerData.directorName === '') {
      errors.directorName = 'Required*';
    }
    if (this.registerData.emailAddress === '') {
      errors.emailAddress = 'Required*';
    } else if (!this.validateEmail(this.registerData.emailAddress)) {
      errors.emailAddress = 'Please use a valid email*';
    }
    if (this.registerData.description === '') {
      errors.description = 'Required*';
    }
    console.log(errors);
    return errors;
  };
  validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  startTypingEffect(): void {
    const currentIndex = this.loopIndex % this.texts.length;
    const fullText = this.texts[currentIndex];

    if (this.isDeleting) {
      this.currentText = fullText.substring(0, this.charIndex--);
    } else {
      this.currentText = fullText.substring(0, this.charIndex++);
    }

    if (!this.isDeleting && this.charIndex === fullText.length) {
      setTimeout(() => (this.isDeleting = true), this.pauseTime);
    } else if (this.isDeleting && this.charIndex === 0) {
      this.isDeleting = false;
      this.loopIndex++;
      setTimeout(() => this.startTypingEffect(), this.pauseTime);
      return;
    }

    const speed = this.isDeleting ? this.backspaceSpeed : this.typingSpeed;
    setTimeout(() => this.startTypingEffect(), speed);
  }
  setOTP = (otp: any) => {
    this.otp = otp;
    if(this.otp.length == 6){this.register()}
  };

  sendOTP = () => {
    this.loading = true;
    if (Object.keys(this.validateForm()).length > 0) {
      this.errors = { ...this.errors, ...this.validateForm() };
    } else {
    this.authService.register(this.registerData).subscribe(
      (res: any) => {
        if (res.statusCode === 200) {
          this.loading = false
          console.log(res);
           this.OTPState = !this.OTPState;
         this.otpId =  res.data.otpId;
         this.notification.success(
          'Success',
          'OTP Sent Successfuly',
          { nzClass: 'notification' }
        );
        } else {
        }
      },
      (error) => {
        this.loading = false;
        this.notification.error(
          'Error',
          'Something went wrong',
          { nzClass: 'notification' }
        );
      }
    );}
  };
  register = () => {
    this.loading = true
    this.registerData.otpId = this.otpId;
    this.registerData.otp = this.otp;
    this.authService.register(this.registerData).subscribe(
      (res: any) => {
        if (res.statusCode === 200) {
         this.otpId =  res.data.otpId;
         this.routeTo('dashboard');
         this.loading = false;
         this.notification.success(
          'Success',
          'Registration Successful',
          { nzClass: 'notification' }
        );
        } else {
        }
      },
      (error) => {
        this.loading = false;
        this.notification.error(
          'Error',
          'Something went wrong',
          { nzClass: 'notification' }
        );
      }
    );
  }
}
